
import React, { useEffect, useState } from 'react';
import styles from '../../../../styles/modules/RegistrationSetup.module.css';
import CustomCheckbox from '../../../CustomComponents/CustomCheckbox/CustomCheckbox';
import { Accordion, AccordionDetails, AccordionSummary, TextField, Typography } from '@mui/material';
import { FormTemplateAPI } from '../../../../api/FormTemplateAPI'
import Loader from '../../../../component/Loader';
import { Privileges } from '../../../../util/PrivilegeConstants';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../../redux/reducer/rootReducer';
import { useNavigate } from 'react-router';
import * as Yup from 'yup';
import { getLogoByPaymentMethodName } from '../../../../util/PaymentUtil';

const validationObj = Yup.object({
    name: Yup.string().required("Payment Method Name Required"),
    desc: Yup.string().required("Payment Method Description Required")
})

const FormPayments = ({ formTemplateId, privileges, formtemplateStatus }) => {
    const [offlinePaymentMethod, setOfflinePaymentMethod] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [isAgree, setIsAgree] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [paymentMethodType, setPaymentMethodType] = useState([])
    const [onlinePayMethods, setOnlinePayMethods] = useState([]);
    const [fieldErrors, setFieldErrors] = useState({})
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const collectData = (type, pm, isAttach,desc) => {
        const updateList = (prev) => {
            let newList = [...prev];
            if (isAttach) {
                if (!newList.some(item => item.id === pm.id)) {
                    newList.push(pm);
                }
            } else {
                newList = newList.filter(item => item.id !== pm.id);
            }
            newList = newList.map((data) => data.id === pm.id ? { ...data, payMethodDesc: desc } : data);                
            return newList;
        };

        

        if (type === 'online_payment') {
            setOnlinePayMethods(updateList);
        } else {
            setOfflinePaymentMethod(updateList);
        }

        if (Object.keys(fieldErrors).length !== 0) {
            setFieldErrors({});
        }
    };


    const handlePaymentMethodType = (type, val) => {
        if (val) {
            if (!paymentMethodType.includes(type)) {
                setPaymentMethodType(prev => [...prev, type])
            }
        } else {
            if (type === 'offline_payment') {
                setOfflinePaymentMethod([]);
            }
            if (type === 'online_payment') {
                setOnlinePayMethods([]);
            }
            setPaymentMethodType(paymentMethodType.filter(item => item !== type));
        }
        Object.keys(fieldErrors).length != 0 && setFieldErrors({});
    };
    const getAllPaymentMethod = async () => {
        try {
            setIsLoading(true);
            const response = await FormTemplateAPI.getAllPaymentMethod();
            setPaymentMethods(response.Data);

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const getAllAttachedPaymentMethod = async () => {
        try {
            setIsLoading(true);
            const response = await FormTemplateAPI.getAllAttachedPaymentMethod(formTemplateId);
            setOnlinePayMethods(response.Data.onlinePaymentMethods);
            setOfflinePaymentMethod(response.Data.offlinePaymentMethods)
            if (response.Data.onlinePaymentMethods.length != 0) {
                handlePaymentMethodType('online_payment', true)
            }
            if (response.Data.offlinePaymentMethods.length != 0) {
                handlePaymentMethodType('offline_payment', true)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleSubmitFormTemplate = async () => {
        try {
            if (!isAgree) {
                dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: 'Please check the concent.' }));
                return;
            }
            setIsLoading(true);
            await FormTemplateAPI.putSendFormTemplateForApprove(formTemplateId);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Your request is submitted successfully.' }));
            navigate('/registration-setup')
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    
    const handleAttachPaymentMethod = async () => {
        try {
            if (paymentMethodType.length == 0) {
                dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: 'Please select atleast one payment method' }));
                return;
            }
        
            if (paymentMethodType?.includes('online_payment') && onlinePayMethods.length == 0) {
                setFieldErrors({ ...fieldErrors, ['online_payment']: "Please select at least one payment method from the online payment options, or deselect the online payment method." })
                return;
            }
            if (paymentMethodType?.includes('offline_payment') && offlinePaymentMethod.length == 0) {
                setFieldErrors({ ...fieldErrors, ['offline_payment']: "Please select at least one payment method from the offline payment options, or deselect the offline payment method." })
                return;
            }
            setIsLoading(true);
            const reqData = {
                formTemplateId: formTemplateId,
                onlinePaymentMethods: onlinePayMethods,
                offlinePaymentMethods: offlinePaymentMethod
            }

            await FormTemplateAPI.postAttachPaymentMethod(reqData);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Payment method updated successfully' }));
        } catch (error) {
            console.error(error);

            if (error.inner) {
                let errObj = {};
                error.inner.forEach(err => {
                    errObj[err.path] = err.message;
                })
                setFieldErrors(errObj)
            } else {
                dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Please contact support' }));
            }
        } finally {
            setIsLoading(false);
        }
    };

    const collectOfflinePayMethodData = (event, id) => {
        const { name, value } = event.target;
        setOfflinePaymentMethod(prev => ({ ...prev, id: id, [name]: value }));
        Object.keys(fieldErrors).length != 0 && setFieldErrors({});
    };


    useEffect(() => {
        getAllPaymentMethod();
        getAllAttachedPaymentMethod();
    }, [])




    return (
        <div className={styles['form_payment_container']}>
            <div className={styles['form_payment_con']}>
                {isLoading && <Loader />}
                <h1>Payment Methods</h1>
                <div className={styles['form_payment_method_list']}>
                    {
                        Object.entries(paymentMethods)?.map(([key, value]) =>
                            <React.Fragment key={key}>
                                <div className={styles['form_payment_method_card']}>
                                    <CustomCheckbox onChange={(event) => handlePaymentMethodType(key, event.target.checked, value)} checked={paymentMethodType?.includes(key)} />
                                    <p>{key?.replaceAll("_", " ")}</p>
                                </div>
                                <p className={styles['online_pay_method_error']}>
                                    {key == 'online_payment' ? fieldErrors['online_payment'] : fieldErrors['offline_payment']}
                                </p>
                                <div className={styles['online_payment_method_list']}>
                                    {value?.map((pm, index) =>
                                        <Accordion 
                                            expanded={key == 'online_payment' ? onlinePayMethods?.some(item => item.id === pm.id) :
                                                offlinePaymentMethod?.some(item => item.id === pm.id)}
                                        elevation={0}
                                            sx={{ 
                                                boxShadow:'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
                                                borderRadius:'10px',
                                                height:'max-content',
                                                minHeight: 0,
                                                margin: 0,
                                                padding:0,
                                                '&.Mui-expanded': {
                                                    minHeight: 0,
                                                    margin: 0
                                                },
                                            }}
                                  
                                        >
                                            <AccordionSummary
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                               
                                            >

                                                <div onClick={(e) => e.stopPropagation()} key={index} className={styles['online_payment_method_card']}>
                                                    <div key={index} className={styles['online_payment_method_card_heading']}>
                                                        <img src={getLogoByPaymentMethodName(pm?.paymentMethodName?.replaceAll("_", " "))} alt="credit card" />
                                                        <h4>{pm?.paymentMethodName?.replaceAll("_", " ")}</h4>
                                                    </div>
                                                    <CustomCheckbox onChange={(e) => collectData(key, pm, e.target.checked)} checked={
                                                        key == 'online_payment' ? onlinePayMethods?.some(item => item.id === pm.id) :
                                                            offlinePaymentMethod?.some(item => item.id === pm.id)
                                                    } />
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Typography>
                                                    <TextField
                                                         fullWidth
                                                        className={styles['form_text_field_theme']}
                                                        multiline
                                                        inputProps={{ maxLength: 500 }}
                                                        name='desc'
                                                        minRows={1}
                                                        label="Description"
                                                        value={key == 'offline_payment' ? offlinePaymentMethod?.find(data => data.id === pm.id)?.payMethodDesc??'' : onlinePayMethods?.find(data => data.id === pm.id)?.payMethodDesc??''}
                                                        onChange={(event) => collectData(key, pm, true,event.target.value)} />
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>)}
                                </div>
                            </React.Fragment>
                        )
                    }
                </div>
                {(privileges?.MANAGE_PAYMENT?.includes(Privileges.MODIFY) && formtemplateStatus === 'IN_PROGRESS') &&
                    <div className={styles['form_payment_save_btn_con']}>
                        <button className={styles['form_payment_save_btn']} onClick={handleAttachPaymentMethod}>Save</button>
                    </div>}
            </div>
            {formtemplateStatus === 'IN_PROGRESS' &&
                <div className={styles['form_template_submit_con']}>
                    <div className={styles['concent']}>
                        <CustomCheckbox checked={isAgree} onChange={(e) => setIsAgree(e.target.checked)} />
                        <p>  I confirm that all the information provided above is true and complete. I understand that this form will be submitted for admin review and approval.
                        </p>
                    </div>
                    {privileges?.MANAGE_PAYMENT?.includes(Privileges.MODIFY) &&
                        <div className={styles['form_payment_save_btn_con']}>
                            <button className={styles['form_payment_save_btn']} onClick={handleSubmitFormTemplate}>Submit For Approval</button>
                        </div>
                    }
                </div>}
        </div>
    )
}

export default FormPayments